import React, { FC } from "react";
import { TooltipProps } from "@material-ui/core";
import StyledTooltip from "./StyledTooltip";

interface IconProps {
  icon?: any;
  path?: string;
  tooltip?: string;
  placement?: TooltipProps["placement"];
  width: string;
  height: string;
}

const Icon: FC<IconProps> = ({ icon, path, tooltip, placement, width, height }) => {
  if (tooltip) {
    return (
      <StyledTooltip placement={placement} title={tooltip} style={{ width, height }} arrow>
        {icon ?? <img src={path} style={{ width, height }} alt={tooltip} />}
      </StyledTooltip>
    );
  }

  return <>{icon ?? <img src={path} style={{ width, height }} alt={tooltip} />}</>;
};

export default Icon;
